/**
 * Created by Victor Rojo on 1/9/17.
 */
import { Component }    from '@angular/core';
import { trigger,state,style,transition,animate,keyframes } from '@angular/animations';
import { AuthService }  from '../auth.service';
import { Credential }   from '../credential';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  animations: [
    trigger('shake', [
      state('off', style({ })),
      state('on',   style({ })),
      transition('off => on', animate('400ms ease-in-out', keyframes([
        style({transform: 'translateX(0)', offset: 0}),
        style({transform: 'translateX(-6px) rotateY(-5deg)',  offset: 0.125}),
        style({transform: 'translateX(5px) rotateY(4deg)',  offset: 0.375}),
        style({transform: 'translateX(-3px) rotateY(-2deg)',     offset: 0.625}),
        style({transform: 'translateX(2px) rotateY(1deg)',  offset: 0.875}),
        style({transform: 'translateX(0)',  offset: 1.0}),
      ])))
    ])
  ]
})
export class LoginComponent{

  credentials = {
    username: '',
    password: ''
  };
  rememberMe = false;
  isBusy = false;
  shakeState = 'off';
  tenant = '';
  customization = '';
  isChrome= false;
  cookiePolicy= true;

  constructor(private authService: AuthService) {

    if ( document.location.hostname  == "galp.cloud.ipetrol.es") {
      this.customization = "galp ipetrol";
      this.tenant = "galp";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "ask.cloud.ipetrol.es" ) {
      this.customization = "ask ipetrol";
      this.tenant = "ask";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "ecuador.cloud.ipetrol.es" ) {
      this.customization = "ecuador ipetrol";
      this.tenant = "ecuador";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "q8.cloud.ipetrol.es" ) {
      this.customization = "q8 ipetrol";
      this.tenant = "q8";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "ecomanager.cloud.ipetrol.es" ) {
      this.customization = "ecomanager ipetrol";
      this.tenant = "ecomanager";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "cloud.ipetrol.es" ) {
      this.customization = " ipetrol";
      this.tenant = "";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "hiotera.cloud.iplace.es" ) {
      this.customization = "hiotera";
      this.tenant = "hiotera";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "nacexa.cloud.iplace.es" ) {
      this.customization = "nacexa";
      this.tenant = "nacexa";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "geo4radon.cloud.iplace.es" ) {
      this.customization = "geo4radon";
      this.tenant = "geo4radon";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "freeenergia.cloud.iplace.es" ) {
      this.customization = "freeenergia";
      this.tenant = "freeenergia";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "kontrolwat.cloud.iplace.es"  ) {
      this.customization = "kontrolwat";
      this.tenant = "kontrolwat";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "respira.cloud.iplace.es" ) {
      this.customization = "respira";
      this.tenant = "respira";
      this.cookiePolicy = false;
    } else if ( document.location.hostname == "iotino.cloud.iplace.es" ) {
      this.customization = "iotino";
      this.tenant = "iotino";
      this.cookiePolicy = false;
    } else if ( document.location.hostname == "depourense.cloud.iplace.es" ) {
      this.customization = "depourense";
      this.tenant = "depourense";
      this.cookiePolicy = false;
    } else if ( document.location.hostname == "h2h.cloud.iplace.es" ) {
      this.customization = "h2h";
      this.tenant = "h2h";
      this.cookiePolicy = false;
    } else if ( document.location.hostname == "hacsuite.cloud.iplace.es" ) {
      this.customization = "hacsuite";
      this.tenant = "hacsuite";
      this.cookiePolicy = false;
    } else {
      this.customization = "smartpadel";
      this.tenant = "smartpadel";
      this.cookiePolicy = false;
    }

    let browserWindow:any = window;
    this.isChrome = !!browserWindow.chrome;
  }

  login():void{
    let credential = new Credential(this.credentials.username, this.credentials.password);
    this.isBusy = true;
    this.shakeState = 'off';
    this.authService
      .login(credential, this.rememberMe)
      .then( response => {
        this.isBusy = false;
      })
      .catch(error => {
        this.isBusy = false;
        this.shakeState = 'on';
      });
  }

  hideCookieAlert() {
    this.cookiePolicy = false;
  }
}
